import { Expansion } from '@/lib/types/common/Expansion';
import { MapType } from '@/lib/types/common/MapType';

// Expansion configuration - source of truth
export const EXPANSION_CONFIG = [
    {
        name: 'game.config.expansions.aRealmReborn',
        expansion: Expansion.ARR,
        icon: `/expansions/${Expansion.ARR.toLowerCase()}.png`
    },
    {
        name: 'game.config.expansions.heavensward',
        expansion: Expansion.HW,
        icon: `/expansions/${Expansion.HW.toLowerCase()}.png`
    },
    {
        name: 'game.config.expansions.stormblood',
        expansion: Expansion.SB,
        icon: `/expansions/${Expansion.SB.toLowerCase()}.png`
    },
    {
        name: 'game.config.expansions.shadowbringers',
        expansion: Expansion.ShB,
        icon: `/expansions/${Expansion.ShB.toLowerCase()}.png`
    },
    {
        name: 'game.config.expansions.endwalker',
        expansion: Expansion.EW,
        icon: `/expansions/${Expansion.EW.toLowerCase()}.png`
    },
    {
        name: 'game.config.expansions.dawntrail',
        expansion: Expansion.DT,
        icon: `/expansions/${Expansion.DT.toLowerCase()}.png`
    }
];

// Map type configuration - source of truth
export const MAP_TYPE_CONFIG = [
    {
        name: 'mapTypes.overworld',
        mapType: MapType.MAP,
        icon: '/mapTypes/overworld.png'
    },
    {
        name: 'mapTypes.dungeons',
        mapType: MapType.DUNGEON,
        icon: '/mapTypes/dungeon.png'
    },
    {
        name: 'mapTypes.trials',
        mapType: MapType.TRIAL,
        icon: '/mapTypes/trial.png'
    },
    {
        name: 'mapTypes.raids8',
        mapType: MapType.RAID8,
        icon: '/mapTypes/raid8.png'
    },
    {
        name: 'mapTypes.raids24',
        mapType: MapType.RAID24,
        icon: '/mapTypes/raid24.png'
    },
    {
        name: 'mapTypes.other',
        mapType: MapType.OTHER,
        icon: '/mapTypes/other.png'
    }
];

// Utility functions
export const getExpansionConfig = (expansion: string) => {
    return EXPANSION_CONFIG.find(config => config.expansion === expansion);
};

export const getMapTypeConfig = (mapType: string) => {
    return MAP_TYPE_CONFIG.find(config => config.mapType === mapType);
};

export const getExpansionName = (expansion: string, t: (key: string) => string) => {
    const config = getExpansionConfig(expansion);
    return config ? t(config.name) : expansion;
};

export const getMapTypeName = (mapType: string, t: (key: string) => string) => {
    const config = getMapTypeConfig(mapType);
    return config ? t(config.name) : mapType;
};

export const getExpansionIcon = (expansion: string) => {
    const config = getExpansionConfig(expansion);
    return config ? config.icon : `/expansions/${expansion.toLowerCase()}.png`;
};

export const getMapTypeIcon = (mapType: string) => {
    const config = getMapTypeConfig(mapType);
    return config ? config.icon : `/mapTypes/${mapType.toLowerCase()}.png`;
};